// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"26f64380","98":"67f0e617","220":"a6371c99","277":"973e7796","453":"ad3a79b6","527":"76118ec6"}[chunkId] + ".chunk.js";
};